import { render, staticRenderFns } from "./PosInvoiceTool.vue?vue&type=template&id=c88b4ab6&scoped=true"
import script from "./PosInvoiceTool.vue?vue&type=script&lang=js"
export * from "./PosInvoiceTool.vue?vue&type=script&lang=js"
import style0 from "./PosInvoiceTool.vue?vue&type=style&index=0&id=c88b4ab6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c88b4ab6",
  null
  
)

export default component.exports